<template>
  <el-dialog
    title="Schedule a Report"
    lock-scroll
    width="30%"
    :visible.sync="popupScheduleOpen"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('closePopup', true)"
  >
    <el-form
      ref="form"
      id="report-schedule"
      class="flex flex-col w-full h-full bg-white space-y-2 shadow-xl p-4 pt-0"
      v-loading="loading"
      :model="form"
      :rules="formRules"
    >
      <div class="w-full flex flex-col space-y-2 p-4">
        <el-form-item label="Name " prop="SchedulerName">
          <el-input v-model="form.SchedulerName" placeholder="Name" clearable />
        </el-form-item>
        <div class="w-full flex space-x-0 space-y-2 lg:space-x-2 lg:space-y-0">
          <el-form-item class="w-full" label="Period" prop="Period">
            <el-select
              v-model="form.Period"
              placeholder="Select Report Period"
              clearable
            >
              <el-option
                v-for="item in dateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            prop="Day"
            label="Every"
            class="w-full"
            v-if="form.Period == 'weekly'"
          >
            <el-select
              v-model="form.Day"
              placeholder="Select the Day"
              class="w-full"
              clearable
            >
              <el-option
                v-for="(item, index) in dayOfWeek"
                :key="item"
                :label="item"
                :value="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            prop="Day"
            label="Every"
            class="w-full"
            v-if="form.Period == 'monthly'"
          >
            <el-select
              v-model="form.Day"
              placeholder="Select the Date"
              class="w-full"
              clearable
            >
              <el-option
                v-for="days in 30"
                :key="days"
                :label="days"
                :value="days"
              />
            </el-select>
          </el-form-item>
        </div>
      </div>

      <div class="flex justify-end mt-2">
        <el-button type="primary" @click="submit" v-if="allowToSubmit"
          >Submit</el-button
        >
        <el-button @click="$emit('closePopup', true)">Close</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
// import dummSensors from '@/components/Reports/dummy-sensor.json'

export default {
  props: {
    reportForm: {
      type: Object
    },
    popupScheduleOpen: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      loading: false,
      form: {
        SchedulerName: '',
        Period: 'daily',
        Day: 0,
        saveAsScheduledReport: false
      },
      dateOptions: [
        {
          value: 'daily',
          label: 'Daily'
        },
        {
          value: 'weekly',
          label: 'Weekly'
        },
        {
          value: 'monthly',
          label: 'Monthly'
        }
      ],
      dayOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
      ],
      formRules: {
        SchedulerName: [
          {
            required: true,
            message: 'Name is required',
            trigger: 'change'
          }
        ],
        Day: [
          {
            required: true,
            message: 'Day is required',
            trigger: 'change'
          }
        ],
        Period: [
          {
            required: true,
            message: 'Schedule Period is required',
            trigger: 'change'
          }
        ]
      },
      sidebarOpen: true,
      allowToSubmit: true
    }
  },
  mounted() {},
  methods: {
    async submit() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.contentLoading = true

          // append ParamJsonObject
          this.form.CustomerName = this.reportForm.customer
          this.form.ParamJsonObject = this.reportForm

          const res = await this.$axios.post(
            this.$appInfo.api.mailList.createSchedulingReport,
            this.form
          )
          this.reportData = {
            form: this.form,
            report: res.data
          }

          this.$message.success(
            'Report Schedule Saved, You can check this data on Scheduled Report menu'
          )
          this.contentLoading = false
          this.allowToSubmit = false
        } else {
          this.contentLoading = false
          this.$message.warning(
            'Please fill in the Report Schedule Data correctly'
          )
        }
      })
    }
  },
  watch: {
    config: {
      deep: true,
      handler(val) {
        if (val) {
          this.$emit('scheduleData', val)
        }
      }
    },
    'form.Period': {
      handler(val) {
        if (val === 'weekly') {
          this.form.Day = 0
        } else {
          this.form.Day = 1
        }
      }
    },
    popupScheduleOpen: {
      handler(val) {
        if (val) {
          this.allowToSubmit = true
        }
      }
    }
  }
}
</script>

<style>
#report-sidebar .el-select {
  width: 100% !important;
}
#report-sidebar .el-tree {
  max-height: 300px;
  overflow: auto;
}
#report-sidebar .el-form-item {
  margin-bottom: 0 !important;
}
#report-sidebar .el-form-item .el-form-item__error {
  display: none !important;
}
#report-sidebar .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
</style>
